import React from 'react';
import { Hero } from './components/sections/Hero';
import { Capacity } from './components/sections/Capacity';
import { Minimums } from './components/sections/Minimums';
import { QuickEstimate } from './components/sections/QuickEstimate';
import { FoodExperience } from './components/sections/FoodExperience';
import { BarExperience } from './components/sections/BarExperience';
import { Enhancements } from './components/sections/Enhancements';
import { Policies } from './components/sections/Policies';
import { Footer } from './components/sections/Footer';
import { Navigation } from './components/Navigation';

function App() {
  return (
    <div className="min-h-screen bg-vintage-white overflow-x-hidden">
      <Navigation />
      <main>
        <Hero />
        <Capacity />
        <Minimums />
        <QuickEstimate />
        <FoodExperience />
        <BarExperience />
        <Enhancements />
        <Policies />
      </main>
      <Footer />
    </div>
  );
}

export default App;